import AssignmentIcon from '@material-ui/icons/Assignment';
import MaterialTable, { Column } from 'material-table';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getConfirmUsers } from '../../store/actions/users';
import { UserState } from '../../store/reducers/user';
import { ConfirmUser } from '../../models/ConfirmUser';
import { useHistory } from 'react-router-dom';

interface RootState {
  user: UserState;
}

const ConfirmCase: React.FC = () => {
  const columns: Column<ConfirmUser>[] = [
    { title: 'Name', field: 'name', searchable: false },
    { title: 'IC No.', field: 'icNumber', searchable: true },
    { title: 'Contact Number', field: 'contactNumber', searchable: false },
    { title: 'Email', field: 'email', searchable: false },
  ];

  const confirmUsers = useSelector(
    (state: RootState) => state.user.confirmUsers
  );

  const history = useHistory();

  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchConfirmUsers = async () => {
      setIsLoading(true);
      try {
        await dispatch(getConfirmUsers());
        setIsLoading(false);
      } catch (error) {
        console.log(error.message);
        setIsLoading(false);
      }
    };

    fetchConfirmUsers();
  }, [dispatch]);

  const getPageSize = (): number => {
    if (confirmUsers.length < 5) {
      return 5;
    } else if (confirmUsers.length < 10) {
      return 10;
    } else if (confirmUsers.length < 15) {
      return 15;
    } else {
      return 20;
    }
  };

  const navigateToYellowHandler = (event: any, redUser: any) => {
    history.push('/confirm-case/' + redUser!!.id);
  };

  return (
    <>
      <MaterialTable
        isLoading={isLoading}
        key={confirmUsers.length}
        localization={{
          toolbar: { searchPlaceholder: 'Search IC No.' },
        }}
        options={{
          search: true,
          pageSize: getPageSize(),
          pageSizeOptions: [],
          actionsColumnIndex: -1,
        }}
        columns={columns}
        data={confirmUsers}
        title="Confirm Cases"
        actions={[
          (rowData) => ({
            icon: () => <AssignmentIcon />,
            tooltip: 'Close Contacts',
            onClick: navigateToYellowHandler,
          }),
        ]}
      />
    </>
  );
};

export default ConfirmCase;
